import { ADMIN_ACCESS_CODE_SEARCH } from './index';
import { Action } from '../action';

export class AdminAccessCodeSearchInitAction implements Action {
	readonly type = ADMIN_ACCESS_CODE_SEARCH.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminAccessCodeSearchDestroyAction implements Action {
	readonly type = ADMIN_ACCESS_CODE_SEARCH.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminAccessCodeSearchHydrateAction implements Action {
	readonly type = ADMIN_ACCESS_CODE_SEARCH.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminAccessCodeSearchHydrateSuccessAction implements Action {
	readonly type = ADMIN_ACCESS_CODE_SEARCH.HYDRATE_SUCCESS;
	constructor(
		public payload: any[],
		public correlationId?: number
	) {}
}

export class AdminAccessCodeSearchHydrateFailureAction implements Action {
	readonly type = ADMIN_ACCESS_CODE_SEARCH.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
